/* exported formValidationSetup, refreshErrorMessages */
/* jshint unused:false */
import axios from 'axios';
import { notification } from 'antd';
import { store } from './localStorage';
import { LOGOUT } from '../pages/auth/ducks';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
  returnRejectedPromiseOnError: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

const openAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const secureAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  // timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const retryAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 600000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const secureRequestMiddlewareOptions = {
  returnRejectedPromiseOnError: true,
  interceptors: {
    request: [
      {
        success: async ({ getState, dispatch, getSourceAction }, req) => {
          req.headers = {
            Authorization: `bearer ${await window.localStorage.getItem('access_token')}`,
          };

          return req;
        },
        error: ({ getState, dispatch, getSourceAction }, req) => req,
      },
    ],
    response: [
      {
        success: ({ getState, dispatch, getSourceAction }, res) => res,
        error: async ({ getState, dispatch }, res) => {
          // If error is 401, retry the request again
          if (res.response && res.response.status === 401) {
            // Since it is an auth error, refresh token
            const result = await openAxiosInstance
              .post('/v2/refresh', {
                access_token: `${await window.localStorage.getItem('access_token')}`,
              })
              .then(({ data }) => {
                if (typeof data.access_token !== 'undefined') {
                  store('access_token', data.access_token);
                }

                return data;
              })
              // If refresh token is successful, retry the request
              .then(async (data) => {
                const newRequest = res.config;
                newRequest.headers.Authorization = `bearer ${data.access_token}`;

                // Resolve response and error
                const retryResult = await retryAxiosInstance
                  .request(newRequest)
                  .then(retryResponse => retryResponse)
                  .catch(error => Promise.reject(error));

                return retryResult;
              })
              // Finish resolving response
              .then(finalResponse => finalResponse)
              .catch((error) => {
                // If attempt resulted into 401, logout
                if (error.response.status === 401) {
                  dispatch({
                    type: LOGOUT,
                  });
                }

                return Promise.reject(error);
              });

            return result;
          }
          if (res.response && res.response.status === 500) {
            notification.error({
              message: 'Server Error',
              description: 'A server error occured, please contact XDE IT immediately.',
            });
          }
          return Promise.reject(res);
        },
      },
    ],
  },
};

const openRequestMiddlewareOptions = {
  returnRejectedPromiseOnError: true,
  interceptors: {
    response: [
      {
        success: ({ getState, dispatch, getSourceAction }, res) => res,
        error: ({ getState, dispatch, getSourceAction }, res) => {
          if (!res.response) {
            // dispatch(navigateToOfflineScreen);
          }
          return Promise.reject(res);
        },
      },
    ],
  },
};

export const apiClients = {
  default: {
    client,
  },
  secure: {
    client: secureAxiosInstance,
    options: secureRequestMiddlewareOptions,
  },
  open: {
    client: openAxiosInstance,
    options: openRequestMiddlewareOptions,
  },
};
